import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { THEME_EMPTY, emptyArray, resolveTheme, ThemeContext, getStore, isEmpty, getDefaultConfig, defineGlobalVersion } from '../utils';
import BuildInStyle from '../BuildinStyle';
import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';
import C7nConfigProvider from './C7nConfigProvider';
defineGlobalVersion(require('../../package.json'));
var resolveStyleCounts = function resolveStyleCounts() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  Object.keys(data).forEach(function (k) {
    var _ref, _ref$data;
    result[k] = ((_ref = data[k]) === null || _ref === void 0 ? void 0 : (_ref$data = _ref.data) === null || _ref$data === void 0 ? void 0 : _ref$data.length) || 0;
  });
  return result;
};
var Container = function Container(props) {
  var onChange = props.onChange;
  var uedStore = useMemo(function () {
    return getStore();
  }, []);
  var _useState = useState(function () {
      return uedStore.state.scope || emptyArray;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    scopeList = _useState2[0],
    setScopeList = _useState2[1];
  var _useState3 = useState(function () {
      return uedStore.state.themes;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dataMap = _useState4[0],
    setDataMap = _useState4[1];
  var _useState5 = useState(function () {
      return uedStore.state.themeComponents;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    themeComponents = _useState6[0],
    setThemeComponents = _useState6[1];
  var partials = useMemo(function () {
    return uedStore.state.partials;
  }, []);
  var _useState7 = useState(function () {
      var schema = props.defaultTheme || uedStore.state.defaultTheme; // 如果有值， 就不需要进行按需加载

      // 如果有值， 就不需要进行按需加载
      if (schema) {
        var _ref2 = dataMap.get(schema) || {},
          _data2 = _ref2.data,
          loadData = _ref2.loadData,
          _ref2$modifyVars = _ref2.modifyVars,
          themeModifyVars = _ref2$modifyVars === void 0 ? {} : _ref2$modifyVars;
        if (_data2 && !loadData) {
          var finalConfig = getDefaultConfig(_data2);
          var resolvedTheme = resolveTheme(_data2, finalConfig, {
            modifyVars: merge({}, uedStore.state.modifyVars, themeModifyVars) // colors: setting.opts?.colors,
          });

          var styleCounts = resolveStyleCounts(_data2);
          return {
            schema: schema,
            config: finalConfig,
            styleCounts: styleCounts,
            resolvedTheme: resolvedTheme
          };
        }
      }
      return {
        schema: '',
        config: {},
        styleCounts: {},
        resolvedTheme: {}
      };
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    setting = _useState8[0],
    setSetting = _useState8[1];
  var settingRef = useRef(setting);
  settingRef.current = setting;
  var initRef = useRef(false);
  var fetchThemeData = useCallback(function (themeSchema, themeConfig, opts) {
    var _ref3 = dataMap.get(themeSchema) || {},
      _ref3$data = _ref3.data,
      _data = _ref3$data === void 0 ? {} : _ref3$data,
      loadData = _ref3.loadData,
      _ref3$modifyVars = _ref3.modifyVars,
      themeModifyVars = _ref3$modifyVars === void 0 ? {} : _ref3$modifyVars;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _setting$opts;
      var data, finalConfig, resolvedTheme, styleCounts;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {};
              if (!loadData) {
                _context.next = 9;
                break;
              }
              _context.next = 4;
              return loadData();
            case 4:
              data = _context.sent;
              dataMap.set(themeSchema, {
                name: 'themeSchema',
                data: data
              });
              setDataMap(new Map(dataMap));
              _context.next = 10;
              break;
            case 9:
              data = _data;
            case 10:
              finalConfig = themeConfig || getDefaultConfig(data);
              resolvedTheme = resolveTheme(data, finalConfig, {
                modifyVars: merge({}, uedStore.state.modifyVars, themeModifyVars, opts === null || opts === void 0 ? void 0 : opts.data),
                colors: (opts === null || opts === void 0 ? void 0 : opts.colors) || ((_setting$opts = setting.opts) === null || _setting$opts === void 0 ? void 0 : _setting$opts.colors)
              });
              styleCounts = resolveStyleCounts(data);
              return _context.abrupt("return", {
                data: data,
                styleCounts: styleCounts,
                finalConfig: finalConfig,
                resolvedTheme: resolvedTheme
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [dataMap, uedStore.state.modifyVars, setting.opts]);
  useEffect(function () {
    // 只需要执行一次
    if (initRef.current) {
      return;
    }
    initRef.current = true;
    if (settingRef.current.schema) {
      // 如果第一次有值， 就不需要进行按需加载
      return;
    }
    var schema = props.defaultTheme || uedStore.state.defaultTheme || _toConsumableArray(dataMap.keys())[0] || THEME_EMPTY;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$fetchThemeData, styleCounts, finalConfig, resolvedTheme;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchThemeData(schema);
            case 2:
              _yield$fetchThemeData = _context2.sent;
              styleCounts = _yield$fetchThemeData.styleCounts;
              finalConfig = _yield$fetchThemeData.finalConfig;
              resolvedTheme = _yield$fetchThemeData.resolvedTheme;
              setSetting({
                schema: schema,
                config: finalConfig,
                styleCounts: styleCounts,
                resolvedTheme: resolvedTheme
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [dataMap]); // 设置主题(在这里加参数进行设置)

  var setTheme = useCallback(function (themeSchema, themeConfig, opts) {
    if (themeSchema === setting.schema && themeConfig === setting.config && isEqual(opts, setting.opts)) {
      return;
    }
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _yield$fetchThemeData2, styleCounts, finalConfig, resolvedTheme;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchThemeData(themeSchema, themeConfig, opts);
            case 2:
              _yield$fetchThemeData2 = _context3.sent;
              styleCounts = _yield$fetchThemeData2.styleCounts;
              finalConfig = _yield$fetchThemeData2.finalConfig;
              resolvedTheme = _yield$fetchThemeData2.resolvedTheme;
              setSetting({
                schema: themeSchema,
                config: finalConfig,
                resolvedTheme: resolvedTheme,
                styleCounts: styleCounts,
                opts: opts || setting.opts
              });
              onChange === null || onChange === void 0 ? void 0 : onChange({
                config: finalConfig,
                schema: themeSchema
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }, [setting.schema, setting.config, setting.opts, fetchThemeData, onChange]);
  useEffect(function () {
    var uedProvider = getStore();
    var unsubscribe = uedProvider.subscribe(function (state) {
      if (state.scope) {
        setScopeList(state.scope);
      }
      setDataMap(state.themes);
      setThemeComponents(state.themeComponents);
    });
    return function () {
      unsubscribe();
    };
  }, []);
  var contextValue = useMemo(function () {
    var schema = setting.schema,
      config = setting.config,
      resolvedTheme = setting.resolvedTheme;
    return {
      schema: schema,
      config: config,
      dataMap: dataMap,
      fetchThemeData: fetchThemeData,
      scopeList: scopeList,
      resolvedTheme: resolvedTheme,
      originTheme: resolvedTheme,
      styleCounts: setting.styleCounts,
      setTheme: setTheme
    };
  }, [setting, scopeList, setTheme, fetchThemeData]);
  if (!setting.schema) {
    if (props.loadingCom) {
      return React.createElement(props.loadingCom);
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(C7nConfigProvider, null, props.children, _toConsumableArray(themeComponents.entries()).filter(Boolean).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      id = _ref8[0],
      Comp = _ref8[1];
    return (
      // TODO: 移除ONLY的判断
      Comp.__is__buildin__ && isEmpty(setting.schema, setting.resolvedTheme) ? null : /*#__PURE__*/React.createElement(Comp, {
        key: id
      })
    );
  }).filter(Boolean), /*#__PURE__*/React.createElement(BuildInStyle, null), partials.map(function (partial, index) {
    return /*#__PURE__*/(
      // eslint-disable-next-line react/jsx-key
      React.createElement(ThemeContext.Provider, {
        key: index,
        value: _objectSpread(_objectSpread({}, contextValue), {}, {
          schema: 'theme2',
          resolvedTheme: partial.data,
          originTheme: partial.data
        })
      }, partial.templates.map(function (Comp, index) {
        return /*#__PURE__*/React.createElement(Comp, {
          partialSelector: partial.selector,
          targetPrefix: partial.targetPrefix,
          key: partial.name || index
        });
      }))
    );
  })));
};
export default Container;